import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart, ChartConfiguration, ArcElement, Tooltip, Legend, registerables } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import ChartDataLabels from 'chartjs-plugin-datalabels';


Chart.register(...registerables, ChartDataLabels);
const centerTextPlugin = {
  id: 'centerText',
  beforeDraw(chart: any) {
    const dataset = chart?.data?.datasets?.[0];
    if (!dataset || !Array.isArray(dataset.data) || !dataset.data.length) {
      return;
    }

    const total = dataset.data.reduce(
      (sum: number, val: number) => sum + val,
      0
    );

    const ctx = chart.ctx;
    const { width, height } = chart;

    ctx.save();
    ctx.font = '700 22px Inter, system-ui, sans-serif';
    ctx.fillStyle = '#111';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(`Total: $${total.toLocaleString()}`, width / 2, height / 2);
    ctx.restore();
  }
};


Chart.register(centerTextPlugin);
@Component({
  selector: 'app-payments-chart',
  standalone: true,
  imports: [CommonModule, NgChartsModule],
  templateUrl: './payment-charts.component.html'
})
export class PaymentsChartComponent implements OnChanges {

  @Input() data: { label: string; total: number }[] | null = null;

  chartData: ChartConfiguration<'doughnut'>['data'] = {
    labels: [],
    datasets: []
  };

 chartOptions: ChartConfiguration<'doughnut'>['options'] = {
  responsive: true,
  cutout: '70%',
  plugins: {
    legend: {
      position: 'bottom'
    },
    datalabels: {
      color: '#111',
      font: {
        weight: 600,
        size: 12
      },
      formatter: (value: number) => `$${value.toLocaleString()}`
    }
  }
};


  ngOnChanges() {
    if (!this.data || !this.data.length) return;

    this.chartData = {
      labels: this.data.map(d => d.label),
      datasets: [
        {
          data: this.data.map(d => d.total),
          backgroundColor: ['#22c55e', '#f59e0b', '#ef4444']
        }
      ]
    };
  }
}
